import Loading from "../common/Loading";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import {Typography} from "@material-ui/core";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import * as React from "react";
import UseBuildInitializer from "./hooks/UseBuildInitializer";
import RunnerSelector from "./RunnerSelector";

export default function BuildInitializer({hubId, opened, handleLaunch, handleCancel}) {
    if (!opened) return null;

    const {loading, runners, selectedRunner, handleRunnerSelected} = UseBuildInitializer({hubId});

    if (loading) {
        return (<Loading/>);
    }

    return (
        <Dialog
            open={opened}
            onClose={handleCancel}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
        >
            <DialogContent>
                <DialogTitle id="alert-dialog-title">Build Initializer</DialogTitle>
            </DialogContent>
            <DialogContent>
                <Typography>Select Runner (Not required):</Typography>
                <RunnerSelector runners={runners}
                                selectedRunner={selectedRunner}
                                handleRunnerSelected={handleRunnerSelected}
                />
            </DialogContent>
            <DialogActions>
                <Button color="primary"
                        onClick={handleCancel}
                >
                    Cancel
                </Button>
                <Button autoFocus
                        color="primary"
                        onClick={
                            () =>
                                handleLaunch(selectedRunner ? selectedRunner.id : null)
                                    .then(() => handleCancel())
                        }
                >
                    Launch
                </Button>
            </DialogActions>
        </Dialog>
    );
}